import React, { useEffect, useRef } from 'react';
import { checkAddPermission, checkDeletePermission } from '../../../Utils/helper';

const CellContextMenu = ({ x, y, onClose, onAddRemark, onViewRemarks, remarkCount, onViewHistories, showViewHistories, onCloneArrival, onDeleteArrival, showArrivalActions, permissions }) => {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [onClose]);

  // Adjust position if menu goes off-screen
  useEffect(() => {
    if (menuRef.current) {
      const menu = menuRef.current;
      const rect = menu.getBoundingClientRect();
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      let adjustedX = x;
      let adjustedY = y;

      if (rect.right > windowWidth) {
        adjustedX = windowWidth - rect.width - 10;
      }

      if (rect.bottom > windowHeight) {
        adjustedY = windowHeight - rect.height - 10;
      }

      menu.style.left = `${adjustedX}px`;
      menu.style.top = `${adjustedY}px`;
    }
  }, [x, y]);

  return (
    <div
      ref={menuRef}
      className="cell-context-menu"
      style={{
        position: 'fixed',
        left: `${x}px`,
        top: `${y}px`,
        zIndex: 9999,
      }}
    >
      <div className="context-menu-item" onClick={onAddRemark}>
        <img src={window.getPublicUrl('/assets/images/plus-blue.svg')} alt="Add" />
        <span>Add Remark</span>
      </div>
      {remarkCount > 0 && (
        <div className="context-menu-item" onClick={onViewRemarks}>
          <img src={window.getPublicUrl('/assets/images/View_light.svg')} alt="View" />
          <span>View Remarks ({remarkCount})</span>
        </div>
      )}
      {showViewHistories && onViewHistories && (
        <div className="context-menu-item" onClick={onViewHistories}>
          <img src={window.getPublicUrl('/assets/images/View_light.svg')} alt="History" />
          <span>View Histories</span>
        </div>
      )}
      {showArrivalActions && onCloneArrival && checkAddPermission(permissions, 'arrival') && (
        <div className="context-menu-item" onClick={onCloneArrival}>
          <img src={window.getPublicUrl('/assets/images/plus-blue.svg')} alt="Clone" />
          <span>Clone Arrival</span>
        </div>
      )}
      {showArrivalActions && onDeleteArrival && checkDeletePermission(permissions, 'arrival') && (
        <div className="context-menu-item" onClick={onDeleteArrival} style={{ color: '#dc3545' }}>
          <img src={window.getPublicUrl('/assets/images/delete.svg')} alt="Delete" />
          <span>Delete Arrival</span>
        </div>
      )}
    </div>
  );
};

export default CellContextMenu;

